import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function WhatSayAbout() {
    const testimonials = [
        {
            name: "Emily",
            text: "Confident Driver helped me overcome my fear of driving. The lessons were easy to follow, and the instructors were incredibly patient and supportive!",
        },
        {
            name: "Michael",
            text: "The step-by-step guidance and interactive driving simulations made learning so much fun. I passed my driving test on the first attempt!",
        },
        {
            name: "Sophia",
            text: "The road safety lessons were super helpful! Now, I feel confident in handling different driving situations, from highways to city roads.",
        },
        {
            name: "James",
            text: "Confident Driver's mock driving tests gave me real-world practice. I highly recommend this academy to anyone preparing for their driving license!",
        },
    ];

    return (
        <section className="what_say_about">
            <div className="container">
                <div className="row align-items-center">
                    {/* Left heading area */}
                    <div className="col-md-5 mb-3 mb-md-0">
                        <div className="heading">
                            <h4>What do they say about Confident Driver</h4>
                            <p className="w-100">
                                Join Confident Driver today and gain the confidence to drive
                                safely and responsibly on the road!
                            </p>
                            <button className="btn1 mt-3 mt-md-4">Start Learning</button>
                        </div>
                    </div>

                    {/* Right side - Testimonials */}
                    <div className="col-md-7">
                        {/* Mobile Swiper */}
                        <div className="d-md-none">
                            <Swiper
                                modules={[Pagination]}
                                spaceBetween={20}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                className="testimonial-swiper"
                            >
                                {testimonials.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="detail p-3">
                                            <h5>{item.name}</h5>
                                            <p>"{item.text}"</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                        {/* Desktop Marquee remains same */}
                        <div className="flex-vertical d-none d-md-block">
                            <div className="flex-horizontal">
                                <div className="flex-horizontal">
                                    <div className="marquee">
                                        <div className="track-vertical-alt">
                                            <div className="flex-vertical">
                                                {testimonials.map((t, i) => (
                                                    <div className="detail" key={i}>
                                                        <h5>{t.name}</h5>
                                                        <p>"{t.text}"</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="marquee">
                                        <div className="track-vertical">
                                            <div className="flex-vertical">
                                                {testimonials.map((t, i) => (
                                                    <div className="detail" key={i}>
                                                        <h5>{t.name}</h5>
                                                        <p>"{t.text}"</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
